import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { TextField } from 'formik-material-ui'
import { Formik, Form, Field } from 'formik';
import { orderSchema, resolutionsContext } from './ResolutionsContext';
import { ticketContext } from 'views/Ticket/TicketContext';

interface IProps {
    type: 'Customer' | 'Service'
}

let NewOrder = ({ type }: IProps) => {
    let { setStatusDialog } = useContext(ticketContext);
    let service = useContext(resolutionsContext);

    let [isOpen, setOpen] = useState(false);


    return (
        <>
            <Button
                color="secondary"
                size="small"
                variant="outlined"
                onClick={() => setOpen(true)}
            >
                <AddIcon />&nbsp;Add
            </Button>
            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle disableTypography>
                    <Typography variant="h4">Add new {type.toLowerCase()} order</Typography>
                </DialogTitle>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        ...orderSchema.getDefault(),
                        type
                    }}
                    validationSchema={orderSchema}
                    onSubmit={async (values, action) => {
                        let res = await service.saveTicketOrder(values);
                        if (res === true) {
                            setOpen(false);
                            action.resetForm();
                        }
                        else
                            action.setSubmitting(false)
                    }}
                >
                    <Form>
                        <DialogContent>
                            <Grid container item xs>
                                <Field
                                    component={TextField}
                                    label="M3 Order Number"
                                    name="m3orderNumber"
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    fullWidth
                                />
                            </Grid>
                            {type === "Service" &&
                                <Grid container item xs>
                                    <Field
                                        component={TextField}
                                        label="Assignment Number"
                                        name="assignmentNumber"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        margin="dense"
                                        fullWidth
                                    />
                                </Grid>
                            }
                        </DialogContent>

                        <DialogActions>
                            <Button color="primary" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button color="secondary" type="submit">Save</Button>
                        </DialogActions>
                    </Form>
                </Formik>
            </Dialog>
        </>
    )
}

export default NewOrder;